import { create } from 'zustand';
import { ClientType } from 'packages/wb-reddit/src/app/routes/superGrid/mutator/adAccount/utils/utils';
import { RowNode, GridApi } from 'ag-grid-community';

export type MutatingClient = Partial<ClientType> & {
	clientId?: string | undefined,
	clientProfilePicture?: any,
	node?: RowNode
	api?: GridApi
};

export const newClient: MutatingClient = {
	clientId:             '',
	clientProfilePicture: undefined,
	agencyAccount: 	      null,
	users:                [],
	userGroups:           [],
};

type RedditClientMutatorState = {
	mutatingClient?: MutatingClient;
	setMutatingClient: (mutatingClient?: MutatingClient) => void;
};

const useRedditClientMutator = create<RedditClientMutatorState>((set) => ({
	mutatingClient:    undefined,
	setMutatingClient: (mutatingClient) => set({ mutatingClient }),
}));

export default useRedditClientMutator;
